<template>
    <div>
      <input type="file" id="file" ref="file" class="input-file" @change="handleFileUpload()"/>
      {{$i18n.t('CarregarLogo')}}
    </div>
</template>
<script>
export default {
    name: 'file-upload',
    data() {
        return {
          file: ''
        }
    },
    methods: {
      click() {
        this.$refs.file.click();
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append('file', this.file);
        this.$emit('upload', formData);
      }
    }
}
</script>
<style scoped lang="scss">
  .button-upload {
    width: 160px;
    height: 40px;
    background: rgba(0,0,0,0.1);
    padding: 10px;
    color:black;
  }
  .input-file {
    opacity: 0;
    width: 100%;
    height: 40px;
    position: absolute;
    cursor: pointer;
  }
</style>